// extracted by mini-css-extract-plugin
export var details = "_lr-0";
export var inspectorPopover = "_lr-1";